<template>
  <page id="top" class="questionnaire" @scrollChange="scrollChange">
    <zui-header>
    </zui-header>
    <PageNavigater></PageNavigater>
    <div class="contain">
      <div class="top-img"></div>
      <div class="content">
        <el-result icon="success" title="问卷已提交" subTitle="感谢您的参与(●'◡'●)" v-if="false">
          <!--<template slot="extra">
						<el-button type="primary" size="medium" @click="$router.back()">返回</el-button>
					</template>-->
        </el-result>
        <el-divider v-if="false"></el-divider>

        <el-form ref="form" v-if="!empty" label-position="top" :model="model" :disabled="isAnswered" :rules="rules" label-width="100%" v-loading="loading">
          <el-form-item v-for="(item, index) in subjectList" :key="item.id" :label="item.title" :name="item.id" :prop="'subject_' + index">
            <el-radio-group style="display: flex;flex-flow: column nowrap;align-items: flex-start;" v-if="item.questionType === '1'" v-model="model['subject_' + index]">
              <el-radio style="margin-top:10px;margin-bottom: 10px;" v-for="option in item.optionsList" :key="option.id" :label="option.content" :value="option.id" />
            </el-radio-group>

            <el-checkbox-group style="display: flex;flex-flow: column nowrap;align-items: flex-start;" v-if="item.questionType === '2'" v-model="model['subject_' + index]">
              <el-checkbox v-for="option in item.optionsList" :key="option.id" :label="option.content" :name="option.id" :value="option.id" />
            </el-checkbox-group>

            <el-input v-if="item.questionType === '3'" v-model="model['subject_' + index]" type="textarea" />

            <el-select v-if="item.questionType === '4' && item.title === '省'" v-model="model['subject_' + index]" value-key="id" placeholder="请选择" style="width:100%" @change="bindProvinceChange">
              <el-option v-for="i in provinceList" :key="i.id" :label="i.name" :value="i"></el-option>
            </el-select>
            <el-select v-if="item.questionType === '4' && item.title === '市'" v-model="model['subject_' + index]" value-key="id" placeholder="请选择" style="width:100%" @change="bindCityChange">
              <el-option v-for="i in cityList" :key="i.id" :label="i.name" :value="i"></el-option>
            </el-select>
            <el-select v-if="item.questionType === '4' && item.title === '县(区)'" v-model="model['subject_' + index]" value-key="id" placeholder="请选择" style="width:100%" @change="bindCountyChange">
              <el-option v-for="i in countyList" :key="i.id" :label="i.name" :value="i"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="submit" v-if="!isAnswered" v-show="!loading">
            <el-button @click="back">取消</el-button>
            <el-button type="primary" :loading="submitting" @click="submitForm">提交</el-button>
          </el-form-item>
        </el-form>

        <el-result icon="warning" title="暂无问卷" subTitle="暂无问卷信息" v-if="empty">
          <template slot="extra">
            <el-button type="primary" size="medium" @click="$router.back()">返回</el-button>
          </template>
        </el-result>
      </div>
      <!--<div class="detailButton1" v-if="showButton" @click="back()">
				<span>返回上级</span>
			</div>-->
      <div class="detailButton2" v-if="showButton" @click="toTop()">
        <span>回到顶部</span>
      </div>
    </div>
    <zui-footer />
  </page>
</template>

<script>
/** @format */

import { getQuestionnaire, postQuestionnaire, getQuestionnaireRecord, getProvinceList } from '~/api/CmsApi';
import '~/views/less/question.css';
import Page from '~/components/Page';
import ZuiHeader from '~/components/Header';
import ZuiFooter from '~/components/Footer';
export default {
    components: {
        Page,
        ZuiHeader,
        ZuiFooter,
    },
    data() {
        return {
            form: {},
            rules: {},
            // 父级id
            pid: '',
            isAnswered: false,
            // 提交状态
            submitting: false,
            loading: false,
            drawer: false,
            showButton: false,
            subjectList: [],
            optionNumber: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'],
            model: {},
            empty: false,
            isIE: false,
            isUC: false,
            provinceList: [], //省
            cityList: [], //市
            countyList: [], //县
        };
    },
    created() {
        this.loading = true;
        this.initQ();
        if (document.documentMode) this.isIE = true;
        if (navigator.appVersion.indexOf('UBrowser/')) this.isUC = true;
        if ((this.isIE || this.isUC) && !document.body.scrollTo) {
            Element.prototype.scrollTo = function (option) {
                this.scrollLeft = option.left;
                this.scrollTop = option.top;
            };
        }
    },
    mounted: function () {
        this.$nextTick(function () {
            window.addEventListener('scroll', this.onScroll);
        });
    },
    methods: {
        initQ() {
            //查问卷
            getQuestionnaire().then(res => {
                if (res.code === 0 && res.data) {
                    const records = res.data.records || [];
                    if (records.length === 0) {
                        this.empty = true;
                        return false;
                    }

                    // 遍历题目列表，给每道题目都添加一个form表单需要的model双向绑定
                    let hasType4 = 0;
                    records.forEach((rec, index) => {
                        if (rec.questionType == 2) {
                            // 如果是多选题，model的双向绑定是一个数组
                            this.$set(this.model, `subject_${index}`, []);
                        } else {
                            // 其他类型的题，model是个字符串
                            this.$set(this.model, `subject_${index}`, '');
                        }

                        if (rec.required == 1) {
                            const validators = [
                                {
                                    required: true,
                                    message: `该项为必填项`,
                                    trigger: ['blur', 'change'],
                                },
                            ];
                            this.$set(this.rules, `subject_${index}`, validators);
                        }
                        if (rec.questionType == 4) {
                            hasType4++;
                        }
                    });
                    if (hasType4) {
                        this.getProvinceList(1, '');
                    }
                    this.subjectList = records;

                    // 问卷id
                    this.pid = records[0].pid;

                    // 获取当前ip的答题记录，看看当前ip用户是否作答过
                    getQuestionnaireRecord({
                        questionId: this.pid,
                    }).then(res => {
                        // data为null，说明当前用户没用各打过题
                        if (!res.data) {
                            this.$nextTick(() => {
                                this.$refs.form.clearValidate();
                            });
                        } else {
                            // 如果用户打了题，这里返回答题的结果
                            const answerList = res.data || [];
                            answerList.forEach(item => {
                                // 题目
                                const index = records.findIndex(s => s.id == item.subjectId);
                                if (index > -1) {
                                    const currentSubject = records[index];

                                    // 问题类型（1.单选 2.多选 3.手动输入）
                                    if (currentSubject.questionType == 1) {
                                        // 选中的选项
                                        const optionChecked = currentSubject.optionsList.find(x => x.id == item.answerId);
                                        this.$set(this.model, `subject_${index}`, optionChecked ? optionChecked.content : '');
                                    } else if (currentSubject.questionType == 2) {
                                        // 选中的选项
                                        const answerIdList = item.answerId ? item.answerId.split(',') : [];
                                        // 因为是多选，所以需要遍历
                                        const answerLabelList = answerIdList.map(answerId002 => {
                                            const optionChecked = currentSubject.optionsList.find(x => x.id == answerId002);
                                            return optionChecked ? optionChecked.content : '';
                                        });
                                        this.$set(this.model, `subject_${index}`, answerLabelList);
                                    } else if (currentSubject.questionType == 4) {
                                        // 选中的选项
                                        const obj = item.answerId ? JSON.parse(item.answerId) : {};
                                        if (currentSubject.title == item.title && obj.id && (!item.title.indexOf('县') > -1)) {
                                            let type = item.title.indexOf('省') > -1 ? 2 :3;
                                            this.getProvinceList(type, obj.id);
                                        }
                                        this.$set(this.model, `subject_${index}`, obj);
                                    } else {
                                        this.$set(this.model, `subject_${index}`, item.answerId || '');
                                    }
                                }
                            });
                            this.isAnswered = false;
                            this.loading = false;
                        }
                    });
                    this.empty = false;
                } else {
                    this.empty = true;
                    console.warn('没有问卷或获取问卷失败');
                }
                this.loading = false;
            });
        },
        /**
         * 点击提交答题
         */
        submitForm() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    const answer = {
                        questionId: this.pid,
                        ansList: [],
                    };
                    // 遍历每道题，组装答题结果提交给后台
                    this.subjectList.forEach((sub, index) => {
                        let currentAnswer = this.model[`subject_${index}`];
                        if (sub.questionType == 1) {
                            // 单选
                            answer.ansList.push({
                                subjectId: sub.id,
                                answerId: sub.optionsList.find(a => a.content === currentAnswer).id,
                            });
                        } else if (sub.questionType == 2) {
                            // 多选
                            currentAnswer = currentAnswer.map(ans => {
                                return sub.optionsList.find(a => a.content === ans).id;
                            });
                            answer.ansList.push({
                                subjectId: sub.id,
                                answerId: currentAnswer.join(','),
                            });
                        } else if (sub.questionType == 3) {
                            // 填空题
                            answer.ansList.push({
                                subjectId: sub.id,
                                questionId: this.pid,
                                answerId: currentAnswer,
                            });
                        } else if (sub.questionType == 4) {
                            // 选择
                            answer.ansList.push({
                                subjectId: sub.id,
                                questionId: this.pid,
                                answerId: JSON.stringify({
                                    id: currentAnswer.id,
                                    name: currentAnswer.name,
                                }),
                            });
                        }
                    });
                    this.callSubmitApi(answer);
                }
            });
        },
        /**
         * 提交答题结果到后台
         * @param param
         */
        callSubmitApi(param) {
            this.submitting = true;
            postQuestionnaire(param)
                .then(res => {
                    if (res.code === 0) {
                        this.isAnswered = true;
                        this.$message.success('问卷已提交，感谢您的参与~');
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch(e => {
                    this.$message.error(e.message);
                })
                .finally(() => {
                    this.submitting = false;
                });
        },
        // maxLevel  1 查省份 2 市 3 区县
        getProvinceList(maxLevel, pid) {
            let params = {
                maxLevel: maxLevel,
                pid: pid,
            };
            getProvinceList(params).then(res => {
                if (res.code === 0 && res.data) {
                    if (maxLevel == 1) {
                        this.provinceList = res.data || [];
                    } else if (maxLevel == 2) {
                        this.cityList = res.data || [];
                    } else if (maxLevel == 3) {
                        this.countyList = res.data || [];
                    }
                }
            });
        },

        //

        bindProvinceChange(item) {
            console.log(item);
            console.log(this.model['subject_5']);
            this.getProvinceList(2, item.id);
        },
        bindCityChange(item) {
            console.log(item);
            this.getProvinceList(3, item.id);
        },
        bindCountyChange() {},
        onScroll() {
            let scrolled = document.documentElement.scrollTop || document.body.scrollTop; // 586、1063分别为第二个和第三个锚点对应的距离
            if (scrolled > 600) {
                this.showButton = true;
            } else {
                this.showButton = false;
            }
        },
        back() {
            this.$router.go(-1);
        },
        toTop() {
            // document.getElementById('top').scrollIntoView({
            // 	behavior: "smooth"
            // });
            if (this.isIE || this.isUC) this.$children[0].$refs['scrollview'].$refs['wrap'].scrollTop = 0;
            else this.$children[0].$refs['scrollview'].$refs['wrap'].scrollTo({ top: 0, behavior: 'smooth' });
        },
        onSubmit() {
            console.log(this.form);
        },
        scrollChange(height) {
            if (height > 300) {
                this.showButton = true;
            } else {
                this.showButton = false;
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/visitor/questionnaire.vue